import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {DatasourceService} from "../datasource/datasource.service";
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent   {
  username:string;
  password:string;
  public input_data= {
    username: "",
    password: ""
};


  constructor(
    private router: Router,
    private dsService: DatasourceService
  ) { 

    this.username="";
    this.password="";
  }

  

  dologin()
  {
if(this.username=="" || this.username=="undefined" || this.password=="" || this.password=="undefined")
{
  alert('Please enter a valid credential.');
  return false;
}
   
    this.input_data.username=this.username;
    this.input_data.password=this.password;
    this.dsService.dologin(this.input_data).subscribe(result => {
      if(result.status)
      {
        //console.log(result);
        sessionStorage.setItem('userId',result.data.userId.toString());
        sessionStorage.setItem('userName',result.data.userName.toString());
        sessionStorage.setItem('PageSize',result.data.pageSize.toString());
        this.router.navigate(['brokerlist']);
      }
      else{
        alert('Invalid Login.');
      }
  },
      error => {console.error(error)
        alert('There is some error.Please contact to Admin.');
      }
  );

}
}
